import React from 'react';

const Categories = () => (
  <main>
    <h1 className="category-h1">Under Construction!</h1>
  </main>
);

export default Categories;
